<template>
  <transition name="fade">
    <div
      v-if="_snackbarActive"
      class="snack-bar"
    >
      <div class="snack-bar_content">
        <p>{{ $t(_content) }}</p>
      </div>
      <div v-if="_buttonContent" class="snack-bar_btn">
        <WsTextButton001
          primary
          @click="$_snackBarButtonClick()"
        >
          {{ $t(_buttonContent) }}
        </WsTextButton001>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "SnackBar",
  computed: {
    _snackbarActive() {
      return this.$store.state.snackbar.snackbarActive;
    },
    _content() {
      return this.$store.state.snackbar.content;
    },
    _buttonUrl() {
      return this.$store.state.snackbar.buttonUrl;
    },
    _buttonContent() {
      return this.$store.state.snackbar.buttonContent;
    },
  },
  methods: {
    $_snackBarButtonClick() {
      if (!this._buttonUrl) return;
      this.$router.push({
        path: this._buttonUrl,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/snack-bar";
</style>